exports = module.exports = require("../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xform-inline .xform-item {\n  padding-right: 15px;\n}\n.xform-hidden {\n  display: none !important;\n}\n/* 隐藏field的title，可配置在xform标签或ui:schema的classNames属性 */\n.xform-title-hidden label.control-label {\n  display: none !important;\n}\n/* 隐藏xform的提交按钮，xform标签使用 */\n.xform-action-hidden .xform-submit-button {\n  display: none !important;\n}\n", ""]);

// exports
